module.exports = __webpack_public_path__ + "img/car-icon-2-current.2d473ec3.png";